module.exports = __webpack_public_path__ + "img/201110-3.ec8341ee.png";